import { methods, request } from "./base";

const appointmentsApis = {
  getLatestConsultation: async (data?: any) =>
    await request({
      method: methods.GET,
      route: "/gfc/consultation/latest",
      query_params: data,
    }),
  getAppointmentList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/get_appointment_list",
      payload: data,
    }),
  getAppointmentTimeSlots: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/appointment_time_slot",
      payload: data,
    }),
  addAppointment: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/add_appointment",
      payload: data,
    }),
  getCoachList: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/check_bcp_hc_details",
      payload: data,
    }),
  requestCancellation: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/doctor/cancel_appointment",
      payload: data,
    }),
};

export default appointmentsApis;
